import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-info',
  templateUrl: './icon-info.component.html',
  styleUrls: ['./icon-info.component.scss']
})
export class IconInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
